var t=function(t,r){void 0===r&&(r=1);var n=String(Math.round(t)).length-r,a=Math.pow(10,n);return Math.ceil(t/a)*a};export{t as getClosestRoundedNumber};
